import { render, staticRenderFns } from "./DataTablesView.vue?vue&type=template&id=77098df4&"
import script from "./DataTablesView.vue?vue&type=script&lang=js&"
export * from "./DataTablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports